import { useNavigate, useLocation } from "react-router-dom";

export function useSafeNavigate(options = {}) {
  const { fallback = "/" } = options;

  const navigate = useNavigate();
  const location = useLocation();

  return function safeNavigate(to, navOptions = {}) {
    // ---- Safe back navigation
    if (to === -1) {
      if (window.history.length > 1) {
        navigate(-1);
        return;
      }

      navigate(fallback, { replace: true });
      return;
    }

    // ---- Normal navigation
    navigate(to, navOptions);
  };
}